import configService from './service/config.service';
import { prepareRuntime } from './appMount';
import './setupQuill';

configService.IsStandAlone = true;

async function boot() {
  await prepareRuntime('boot');
  await import('./bootloader');
}

boot().catch((error) => console.error('[token-management-ui] boot failed', error));
